import {Pipe, PipeTransform} from '@angular/core';
import {AdminStateEnum} from '../../services/enums/admin-state.enum';

@Pipe({name: 'adminStatePipe'})
export class AdminStatePipe implements PipeTransform {
  transform(value: string): string {
    const adminStateIcon = (value === AdminStateEnum.LOCKED) ? '<i class="fa fa-lock" title="Locked"></i>' : '<i class="fa fa-unlock" title="Unlocked"></i>';

    return `<div class="center-content">${adminStateIcon}</div>`;
  }
}
